/* Built In Imports */
import { useContext, useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import PageConfig from '@msr/Common/PageConfig';
import ShivaTopic from '@msr/components/Card/ShivaTopic';
import ShivaTopicContent from '@msr/components/Card/ShivaTopicContent';
import MsrTopicBanner from '@msr/components/HeaderBanner/MsrTopicBanner';
import MsrSectionTitle from '@msr/components/Headings/MsrSectionTitle';
import WrapLayout from '@msr/components/Layout/WrapLayout';
import Breadcrum from '@msr/components/Navigation/Breadcrum';
import SubscribeForm from '@msr/components/UI/Blogs/SubscribeForm';
import { AuthContext } from '@store/auth-context';

/* Services */
import { getLocale } from '@msr/components/Utility/Shared/SharedService';
import {
    fetchFooterDetailData,
    fetchHeaderMenuData,
} from 'services/commonService';
import { fetchDetails, getLandingPaths } from 'services/msrService';

/**
 *
 * @param {Object} pageData
 * @returns
 */
const ShivaBlogTopic = ({ pageData, topic }) => {
  const authContext = useContext(AuthContext);

  useEffect(() => {
    authContext.RegionAndLang('', 'en');
  }, [authContext, '', 'en']);

  return (
    <WrapLayout pageData={pageData}>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData.availableLocales}
      >
        {' '}
      </HeadComponent>
      {pageData?.breadcrumbs?.length > 0 && (
        <Breadcrum
          page={pageData.breadcrumbs}
          alsoin={pageData.alsoin}
          url=""
          region={''}
          lang={'en'}
        />
      )}
      <Box as="section" className="container-article">
        <MsrTopicBanner
          sectionContent={pageData?.pageContent}
          pageData={pageData}
        />
        <ShivaTopicContent shivaPosts={pageData?.posts} topic={topic} />
        <Box
          maxW="1140px"
          m="30px auto"
          sx={{
            '.titleWrapper': {
              marginLeft: { base: '8px', md: 'auto' },
            },
          }}
        >
          <MsrSectionTitle
            titleObj={{
              titleDecoration: 'white-no-decoration',
              titleSubtext: '',
              titleText: pageData?.pageContent?.json?.exploreTitle,
            }}
            mt="0"
            mb="0"
          />
          <ShivaTopic topics={pageData?.topics} />
        </Box>

        <SubscribeForm />
      </Box>
      <PageConfig isLikeVisible={false} pageData={pageData} />
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const msrPaths = config.USE_LOCAL_URL
    ? [
        `/mahashivratri/shiva/topic/adiyogi`,
        `/mahashivratri/shiva/topic/devotees-of-shiva`,
        `/mahashivratri/shiva/topic/stories-of-shiva`,
      ]
    : await getLandingPaths('L2', '/mahashivratri/shiva/topic', 'shiva_topic');
  return {
    paths: msrPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({ preview,previewData, params: { topic } }) => {
  const headerMenuData = await fetchHeaderMenuData(
    getLocale('IN', 'en'),
    'msrmainmenu'
  );
  const footerData = await fetchFooterDetailData(
    getLocale('IN', 'en'),
    'msrfooter'
  );
  const pageData = await fetchDetails('', '', `shiva/topic/${topic}`, {
    preview,
    data: previewData,
  });

  return {
    props: {
      headerMenuData: headerMenuData?.data || null,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false,
      topic: topic,
      menuType: 'msrmainmenu',
    },
  };
};

export default ShivaBlogTopic;
